import React from "react";
import api from "../api";

export default function PartnerStart() {
  const [email, setEmail] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setMessage("");
    setError("");

    try {
      const { data } = await api.post("/partner-claims/request-by-email", {
        email,
      });

      setMessage(
        data?.message ||
          "If we found Smart Timing history for that email, we sent a secure link."
      );
    } catch (e) {
      setError("Could not send a secure link right now. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md ss-card ss-card-pad">
        <p className="text-xs uppercase tracking-[0.2em] text-orange-300 mb-2">
          Partner Smart Timing
        </p>

        <h1 className="text-2xl font-bold text-white mb-2">
          View your Smart Timing stats
        </h1>

        <p className="text-sm text-textMuted mb-5">
          Enter the email you use with a partner exchange. If we find Smart
          Timing history, we’ll send you a secure link.
        </p>

        <form onSubmit={submit} className="space-y-3">
          <input
            type="email"
            required
            autoComplete="email"
            inputMode="email"
            autoCapitalize="none"
            autoCorrect="off"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={busy}
            className="ss-input"
          />

          <button
            type="submit"
            disabled={busy}
            className="ss-btn-primary w-full py-3 disabled:opacity-60"
          >
            {busy ? "Sending..." : "Send secure link"}
          </button>
        </form>

        {message && (
          <div className="mt-4 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-200">
            {message}
          </div>
        )}

        {error && (
          <div className="mt-4 rounded-xl border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-200">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}